import { render, staticRenderFns } from "./MasterData.vue?vue&type=template&id=a9f56816&scoped=true"
import script from "./MasterData.vue?vue&type=script&lang=js"
export * from "./MasterData.vue?vue&type=script&lang=js"
import style0 from "./MasterData.vue?vue&type=style&index=0&id=a9f56816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f56816",
  null
  
)

export default component.exports